export class DistributorDetails {
    _id?: string;
    name: string;
    street: string;
    postcode: string;
    city: string;
    gpsLocation?: {
        coordinates: number[];
    };
    version: number;
}

export class GoogleMapsApiObject {
    key?: string;
}
